module.exports = __webpack_public_path__ + "static/pak-demo-1e4b1bc938d2b5411578dd6d6ec0ae6e.mp4";